import React from 'react';
import { useTranslation } from 'react-i18next';
import { Title } from '../../styles';
import { useMediaQuery } from '@mui/material';
import MultimediaFormFields from 'modules/Experience/components/MultimediaFormFields';

const MultimediaForm = ({ form }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`experience_form.multimedia.${key}`);
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <React.Fragment>
            <Title title={translate('title')} description={translate('description')} />

            <MultimediaFormFields form={form} cardSize={{ xs: 3, md: 2 }} maxEmpty={isMobile ? 8 : 12} hideLabel />
        </React.Fragment>
    );
};

export default MultimediaForm;
